import { render, staticRenderFns } from "./UserViewNgoCard.vue?vue&type=template&id=3f8455e7&"
import script from "./UserViewNgoCard.vue?vue&type=script&lang=js&"
export * from "./UserViewNgoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports